import {
  MessageSquare,
  Search,
  TrendingUp,
  LineChart,
  Cast,
  Award,
  CheckCircle,
} from 'lucide-react';

const features = [
  {
    icon: <Search className="w-8 h-8 text-brand-roxo" />,
    title: 'Busca inteligente de fornecedores',
    description:
      'A dgenny mapeia fornecedores relevantes para o seu mix, expande sua base e aumenta o poder de negociação.',
  },
  {
    icon: <MessageSquare className="w-8 h-8 text-brand-roxo" />,
    title: 'Negociação no WhatsApp',
    description:
      'A I.A. negocia com múltiplos fornecedores em paralelo no canal que eles já usam — sem treinamento, sem atrito.',
  },
  {
    icon: <TrendingUp className="w-8 h-8 text-brand-roxo" />,
    title: 'Escala sem esforço extra',
    description:
      'Dezenas de cotações rodando ao mesmo tempo. Mais concorrência, melhores condições, time livre para decidir.',
  },
  {
    icon: <LineChart className="w-8 h-8 text-brand-roxo" />,
    title: 'Equalização e análise',
    description:
      'Propostas equalizadas lado a lado: preço, prazo, condição. Decisão de compra virou leitura rápida.',
  },
  {
    icon: <Cast className="w-8 h-8 text-brand-roxo" />,
    title: 'Integra no que você já usa',
    description:
      'Conecta ERP, CRM e planilhas. A dgenny entra no seu processo — você não entra no dela.',
  },
  {
    icon: <Award className="w-8 h-8 text-brand-roxo" />,
    title: 'Economia consistente',
    description:
      'Clientes economizam até 80% nas compras pela combinação de base ampliada e negociação em escala.',
  },
];

export default function Features() {
  return (
    <section id="recursos" className="py-20 md:py-28 bg-white">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block text-brand-roxo font-semibold text-sm uppercase tracking-wider mb-3">
            Por que dgenny
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold text-brand-azul mb-5 leading-tight">
            Compra que escala no ritmo da sua operação
          </h2>
          <p className="text-lg text-brand-azul/70 leading-relaxed">
            Tecnologia com foco em execução. Negociação que entrega — do pedido à decisão.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-7 border border-border hover:border-brand-roxo/40 hover:shadow-lg transition-all"
            >
              <div className="mb-5 w-14 h-14 rounded-xl bg-brand-roxo/10 flex items-center justify-center">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold font-display text-brand-azul mb-2">{feature.title}</h3>
              <p className="text-brand-azul/70 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href="#planos"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-brand-roxo text-white font-semibold rounded-full hover:brightness-110 transition-colors shadow-sm"
          >
            Escolha seu plano <CheckCircle size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
